import { useState, useEffect } from "react";
import { Link, useLocation, NavLink } from "react-router-dom";
import { Menu, X, ArrowRight } from "lucide-react";
import { NAV } from "../data/site";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => setOpen(false), [pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 backdrop-blur-xl border-b ${
        scrolled ? "bg-sand/90 border-line/60 py-3" : "bg-sand/60 border-transparent py-5"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 flex items-center justify-between gap-4">
        <Link to="/" data-testid="logo-link" className="group flex items-center gap-3">
          <img src="/emblem.png" alt="Logo Sandro Services 06" className="h-11 md:h-12 w-auto transition-transform duration-300 group-hover:scale-105" />
          <span className="flex flex-col leading-none">
            <span className="font-display text-2xl md:text-[26px] text-forest tracking-tight">
              SANDRO SERVICES <span className="text-olive">06</span>
            </span>
            <span className="text-[10px] uppercase tracking-[0.35em] text-ink-soft mt-1">
              Entretien · Nettoyage · Extérieurs
            </span>
          </span>
        </Link>

        <nav className="hidden xl:flex items-center gap-7">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.to === "/" ? "home" : n.to.slice(1)}`}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors duration-300 hover:text-olive ${
                  isActive ? "text-olive" : "text-ink-soft"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/contact"
            data-testid="header-devis-btn"
            className="hidden sm:inline-flex items-center gap-2 bg-olive text-white rounded-full px-5 py-3 text-sm font-semibold hover:bg-olive-hover transition-all duration-300 hover:-translate-y-0.5 shadow-md"
          >
            Demander un devis <ArrowRight size={16} />
          </Link>
          <button
            data-testid="menu-toggle"
            onClick={() => setOpen((o) => !o)}
            className="xl:hidden w-11 h-11 grid place-items-center rounded-full border border-line text-forest"
            aria-label="Menu"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="xl:hidden bg-sand border-t border-line mt-3">
          <nav className="px-6 py-6 flex flex-col gap-1">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                data-testid={`mobile-nav-${n.to === "/" ? "home" : n.to.slice(1)}`}
                className={({ isActive }) =>
                  `py-3 text-lg font-display border-b border-line/50 ${
                    isActive ? "text-olive" : "text-forest"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              data-testid="mobile-devis-btn"
              className="mt-4 inline-flex items-center justify-center gap-2 bg-olive text-white rounded-full px-6 py-4 font-semibold"
            >
              Demander un devis <ArrowRight size={18} />
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};
